import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminPositionRoleApi from "../../api/admin/AdminPositonRole";
import {
  CodeDto,
  PositionOrRoleDto,
  UpdatePositionOrRoleRequestDto,
} from "../../../types/adminPositionRole";

const initialState = {
  positionList: [] as PositionOrRoleDto[],
  roleList: [] as PositionOrRoleDto[],
};
export const trunkGetPositionList = createAsyncThunk(
  "wapi/admins/positions",
  async () => {
    const resp = await adminPositionRoleApi.getPositionList();
    return resp;
  }
);
export const trunkInsertPosition = createAsyncThunk(
  "wapi/admins/positions/insert",
  async (name: string) => {
    const resp = await adminPositionRoleApi.insertPosition(name);
    return resp;
  }
);
export const trunkUpdatePosition = createAsyncThunk(
  "wapi/admins/positions/update",
  async (requestOption: UpdatePositionOrRoleRequestDto) => {
    const resp = await adminPositionRoleApi.updatePosition(requestOption);
    return resp;
  }
);
export const trunkDeletePosition = createAsyncThunk(
  "wapi/admins/positions/delete",
  async (code: CodeDto[]) => {
    const resp = await adminPositionRoleApi.deletePosition(code);
    return resp;
  }
);

export const trunkGetRoleList = createAsyncThunk(
  "wapi/admins/roles",
  async () => {
    const resp = await adminPositionRoleApi.getRoleList();
    return resp;
  }
);
export const trunkInsertRole = createAsyncThunk(
  "wapi/admins/roles/insert",
  async (name: string) => {
    const resp = await adminPositionRoleApi.insertRole(name);
    return resp;
  }
);
export const trunkUpdateRole = createAsyncThunk(
  "wapi/admins/roles/update",
  async (requestOption: UpdatePositionOrRoleRequestDto) => {
    const resp = await adminPositionRoleApi.updateRole(requestOption);
    return resp;
  }
);
export const trunkDeleteRole = createAsyncThunk(
  "wapi/admins/roles/delete",
  async (code: CodeDto[]) => {
    const resp = await adminPositionRoleApi.deleteRole(code);
    return resp;
  }
);

const adminPositionRoleSlice = createSlice({
  name: "adminPositionRole",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkGetPositionList.fulfilled,
      (state, { payload: positionInfo }) => {
        state.positionList = positionInfo;
      }
    );
    builder.addCase(
      trunkGetRoleList.fulfilled,
      (state, { payload: roleInfo }) => {
        state.roleList = roleInfo;
      }
    );
    builder.addCase(
      trunkInsertPosition.fulfilled,
      (state, { payload: newPosition }) => {
        state.positionList.push(newPosition);
      }
    );
    builder.addCase(
      trunkUpdatePosition.fulfilled,
      (state, { payload: updatePosition }) => {
        state.positionList.filter(
          (item) => item.code === updatePosition.code
        )[0].name = updatePosition.name;
        state.positionList.filter(
          (item) => item.code === updatePosition.code
        )[0].order = updatePosition.order;
      }
    );
    builder.addCase(
      trunkDeletePosition.fulfilled,
      (state, { payload: positionInfo }) => {
        state.positionList = positionInfo;
      }
    );
    builder.addCase(
      trunkInsertRole.fulfilled,
      (state, { payload: newRole }) => {
        state.roleList.push(newRole);
      }
    );
    builder.addCase(
      trunkUpdateRole.fulfilled,
      (state, { payload: updateRole }) => {
        state.roleList.filter((item) => item.code === updateRole.code)[0].name =
          updateRole.name;
        state.roleList.filter(
          (item) => item.code === updateRole.code
        )[0].order = updateRole.order;
      }
    );
    builder.addCase(
      trunkDeleteRole.fulfilled,
      (state, { payload: roleInfo }) => {
        state.roleList = roleInfo;
      }
    );
  },
});

export const adminPositionRoleActions = adminPositionRoleSlice.actions;
export default adminPositionRoleSlice.reducer;
